@if (content) {
  <h3>{{ content.title }}</h3>
}